/**
 * How It Works Page — interactions
 *
 * 1. Blur + fade reveal animations (IntersectionObserver)
 * 2. Smooth accordion toggle (grid-template-rows transition)
 *
 * Fully disabled with prefers-reduced-motion.
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     1. Scroll Reveal
     ------------------------------------------------------------------ */
  function initReveal() {
    var els = document.querySelectorAll('.hiw-reveal');
    if (!els.length) return;

    if (prefersReducedMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------
     2. Accordion — toggles aria-expanded + .is-open for CSS animation
     ------------------------------------------------------------------ */
  function initAccordions() {
    var triggers = document.querySelectorAll('.hiw-accordion__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var controlsId = trigger.getAttribute('aria-controls');
        var body = document.getElementById(controlsId);

        if (!body) return;

        trigger.setAttribute('aria-expanded', String(!expanded));
        body.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* ------------------------------------------------------------------
     3. Init
     ------------------------------------------------------------------ */
  function init() {
    initReveal();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      initReveal();
      initAccordions();
    });
  }
})();
